export function isJsonResponse(response: Response): boolean {
    const contentType = response.headers.get('content-type');
    if (typeof contentType == 'string' && contentType.includes('application/json')) {
        return true;
    }
    return false;
}

export type ProblemDetail = {
    detail: string;
    status: number;
    title: string;
    type: string;
};
export function isProblemDetail(obj: Record<string, unknown>): obj is ProblemDetail {
    if (typeof obj == 'object') {
        if (obj != null) {
            return (obj as ProblemDetail).type == 'https://tools.ietf.org/html/rfc7231#section-6.5.4';
        }
    }
    return false;
}

//"2023-07-13T07:16:36.9811813Z"
const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d*)?Z?(\+\d{2}:\d{2})?$/;

export type JsonType = string | number | boolean | null | JsonType[] | { [key: string]: JsonType };

function reviver(key: string, value: JsonType) {
    if (typeof value === 'string' && dateFormat.test(value)) {
        return new Date(value);
    }

    return value;
}

export async function parseJsonResponseWithDate<T>(response: Response) {
    const text = await response.text();
    return JSON.parse(text, reviver) as T;
}

export function checkFor401AndMaybeLoadLoggedOutPage(response: Response) {
    if (response.status == 401) {
        window.location.href = '/mypage/session/logged-out';
    }
}
